import "vuetify/styles";
import { createVuetify } from "vuetify";
import "@mdi/font/css/materialdesignicons.css";
import "material-design-icons-iconfont/dist/material-design-icons.css";
import { aliases, mdi } from "vuetify/iconsets/mdi";
import { md } from "vuetify/iconsets/md";
import colors from "vuetify/util/colors";
import { StringDateAdapter } from "vuetify/date/adapters/string";

import * as components from "vuetify/components";
import * as directives from "vuetify/directives";

const terracotta = "#c03b32";

const vuetify = createVuetify({
  components,
  directives,
  icons: {
    defaultSet: "mdi",
    aliases,
    sets: { mdi, md },
  },
  theme: {
    defaultTheme: "light",
    variations: {
      colors: ["primary", "secondary"],
      lighten: 1,
      darken: 2,
    },
    themes: {
      light: {
        dark: false,
        colors: {
          primary: terracotta,
          secondary: "#545560",
          accent: "#d0514a",
          slatelight: "#898989",
          salt: "#fbf3e8",
          watercorp: "#006BA6",
          skyblue: "#0066b6",
          skybluelight: "#1da8e9",
          error: colors.red.accent3, // #ff1744
          // background: terracotta,
          background: "#ffffff",
        },
      },
      dark: {
        dark: true,
        colors: {
          primary: colors.orange.darken4, // #e65100
          // background: terracotta,
          background: "#ffffff",
        },
      },
    },
  },
  defaults: {
    VProgressLinear: {
      color: "primary",
    },
    VSelect: {
      variant: "underlined",
      color: "primary",
    },
    VTextField: {
      variant: "underlined",
      color: "primary",
    },
    VDataTable: {
      hover: true,
    },
    VToolbar: {
      color: "white",
    },
    VFileInput: {
      variant: "underlined",
    },
    VTextarea: {
      variant: "underlined",
    },
    VAutocomplete: {
      variant: "underlined",
    },
  },
  date: {
    adapter: StringDateAdapter,
  },
});

export default vuetify;
